module.exports = __webpack_public_path__ + "media/images/icons/filled/heart-ee0558f6bdb951325cf138b4bb2c6777.svg";